import React, { useEffect, useRef } from 'react';
import { toast } from 'sonner';
import { POPUP_NAMES, PRODUCT_IMAGES } from '../utils/constants';
export function PurchasePopup() {
  const timeoutRef = useRef<NodeJS.Timeout>();
  useEffect(() => {
    const showPopup = () => {
      const randomPerson = POPUP_NAMES[Math.floor(Math.random() * POPUP_NAMES.length)];
      toast(<div className="flex items-center gap-3" data-id="element-246">
          <img src={PRODUCT_IMAGES.main} alt="Product" className="w-12 h-12 rounded object-cover" data-id="element-247" />
          <div data-id="element-248">
            <div className="font-semibold text-gray-900" data-id="element-249">
              {randomPerson.name} da {randomPerson.city}
            </div>
            <div className="text-sm text-gray-600" data-id="element-250">
              Ha appena acquistato questo prodotto
            </div>
          </div>
        </div>, {
        duration: 4000,
        position: 'bottom-left'
      });
      // Schedule next popup (15-30 seconds)
      const nextDelay = 15000 + Math.random() * 15000;
      timeoutRef.current = setTimeout(showPopup, nextDelay);
    };
    // First popup after 10 seconds
    timeoutRef.current = setTimeout(showPopup, 10000);
    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, []);
  return null;
}